const CardObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting){
            // console.log('Custom Card Section is in view');
            // console.log(entry.target);

            const dataField = entry.target.dataset;
            const cardMainSection = document.querySelector('.custom-card-section');

            cardMainSection.style.setProperty('--bg', `linear-gradient(135deg, ${dataField.bgcolor1} 0%, ${dataField.bgcolor2} 100%)`);
        }
    });
}, {
    threshold: 0.8
}); 

document.addEventListener('DOMContentLoaded', () => {
    const cardSection = document.querySelectorAll('.custom-card-ingredient');
    console.log('Found cards:', cardSection);
    cardSection.forEach((card) => {
        console.log('Observing card:', card);
        CardObserver.observe(card);
    });
});